import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import "../../common/css/base.css";
import "../../common/css/log.css";

class DashboardLogbuild extends Component {
  render() {
    return (
      <Grid className="dashboard">
        <Typography variant="h5" className="dashboard-title text-bold">
          ダッシュボード
        </Typography>
      </Grid>
    );
  }
}

export default withRouter(DashboardLogbuild);
